export default { 
    login_social_media_error_default: 'Nombre de usuario o contraseña incorrecta',
    login_social_media_error_presignin: 'PreSignUp failed with error',
    login_social_media_error_preauthentication:'PreAuthentication failed with error',
    login_social_media_error: 'Error during the login process',
}